import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=b211fc3a"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
import style0 from "./Modal.vue?vue&type=style&index=0&id=b211fc3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports